import { TableCell, TableRow } from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading rows for a table.
 *
 * Renders the same number of rows the page is about to show, so the table does
 * not resize when real data lands (§64).
 */
export function DataTableSkeleton({
  columnCount,
  rowCount = 10,
}: {
  columnCount: number;
  rowCount?: number;
}) {
  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <TableRow key={rowIndex} className="hover:bg-transparent">
          {Array.from({ length: columnCount }).map((__, columnIndex) => (
            <TableCell key={columnIndex} className="py-2.5">
              {/* Varying widths read as text rather than as a block of bars. */}
              <Skeleton className="h-3.5" style={{ width: `${55 + ((columnIndex * 37) % 40)}%` }} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
